
import Campaigndetailplaceholder from "@/components/placeholders/campaigndetailplaceholder";
import Foot from "@/layouts/foot";

export default {
  name: "index",
  components: {Foot, Campaigndetailplaceholder},
  data() {
    return {
      campaign: {},
      metaTitle: ""
    }
  },
  head() {
    var _ = require('lodash')
    const structuredData = {
      "@context": "http://schema.org",
      "@type": "Article",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": 'https://www.servislet.com' + this.$route.fullPath
      },
      "headline": this.campaign.meta_title || this.campaign.title,
      "description": this.campaign.meta_description,
      "image": _.get(this.campaign, 'banner.asset', ''),
      "author": {
        "@type": "Person",
        "name": "Servislet",
        "url": "https://www.servislet.com"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Servislet",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.servislet.com/img/logo.svg"
        },
      },
      "datePublished": this.campaign.created_at ?? '',
      "dateModified": this.campaign.updated_at ?? ''
    }
    return {
      title: this.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.campaign.meta_description
        },
        { hid: 'keywords', name: 'keywords', content: this.campaign.meta_keywords }
      ],
      script: [
        { type: 'application/ld+json', json: structuredData }
      ]
    }
  },
  async fetch() {
    try {
      if (process.client) {
        this.metaTitle = document.title.replace(' | Tirelet', '')
      }
      var campaign = await this.$http.$get(`/cms/posts/by-slug/${this.$route.params.campaign}`)
      if (campaign.code === 1000) {
        this.campaign = campaign.data.cmsPost
        this.metaTitle = (this.campaign.meta_title ||this.campaign.title)
      }
    }catch (e) {
      this.$router.push(this.localePath({name: 'miscellaneous-error'}))
    }
  }
}
